import React from "react";
import ContactSection from "../components/contact-section/contact-section";

function Contact() {
  return (
    <>
      <ContactSection />
    </>
  );
}

export default Contact;
